export const manifest = {
  screens: {
    scr_l2634f: { name: "Home", route: "/" },
  },
}
